import { useEffect } from 'react'

import { LoginForm } from '../Components/LoginForm'

/**
 * Заголовок вкладки — українською прямо тут (`SPEC-014` §2.1): ключа
 * `Authorization` у перекладах немає, і PD показував його англійською.
 */
export default function LoginPage() {
    useEffect(() => {
        document.title = 'Авторизація'
    }, [])

    return <LoginForm />
}
